document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".has-many-container:has(.normalize)").forEach(container => {
    const inputs = container.querySelectorAll(
      "fieldset.inputs.has-many-fields fieldset.inputs li.input"
    );

    const visibleInputs = Array.from(inputs).filter(
      input => !input.classList.contains("hidden")
    );

    const fieldset = container.querySelector("fieldset.inputs.has-many-fields");
    Object.assign(fieldset.style, {
      border: "none",
      padding: "0",
      margin: "0"
    });

    // Generalized grouping handler
    const handleGrouping = (groups, wrapperClasses = []) => {
      groups.forEach(indices => {
        const elements = indices.map(i => visibleInputs[i]).filter(Boolean);

        if (elements.length === 0) return;

        const wrapper = document.createElement("div");
        wrapper.classList.add(...wrapperClasses);

        elements[0].parentNode.insertBefore(wrapper, elements[0]);
        elements.forEach(el => wrapper.appendChild(el));
      });
    };

    // Config for all associations
    const configs = {
      policy: {
        groups: [
          [0, 1], // Policy holder + Policy number
          [2, 3]  // Effective date + Expiry date
        ],
        classes: ["policy-pair", "grid", "auto-cols-fr", "grid-flow-col", "gap-4", "mb-4"]
      },
      accident: {
        groups: [
          [0, 1],     // Example: first two together
          [2, 3, 4],  // Three together
          [5]         // Single
        ],
        classes: ["accident-pair", "grid", "auto-cols-fr", "grid-flow-col", "gap-4", "mb-4"]
      },
      beneficiary: {
        groups: [
          [0, 1],
          [2, 3],
          [4]
        ],
        classes: ["beneficiary-pair", "grid", "auto-cols-fr", "grid-flow-col", "gap-4", "mb-4"]
      },
      vehicle: {
        groups: [
          [0, 1],
          [2, 3],
          [4, 5],
          [6, 7],
          [8, 9],
          [10, 11],
          [12, 13],
          [14, 15],
          [16, 17],
          [18, 19],
          [20, 21, 22, 23]
        ],
        classes: ["vehicle-pair", "grid", "auto-cols-fr", "grid-flow-col", "gap-4", "mb-4"]
      }
    };

    const config = configs[container.dataset.hasManyAssociation];
    if (config) handleGrouping(config.groups, config.classes);
  });
});
